<template>
    <v-overlay class="text-center" opacity="0.80">
        <v-progress-circular
                color="white"
                indeterminate
        ></v-progress-circular><br/>
        <p class="title pt-4">Please wait while we process your request...</p>
    </v-overlay>
</template>

<script>
    export default {
        name: "SpinnerOverlay"
    }
</script>

<style scoped>

</style>